import { consumer } from "@spawn/core";
import { AttentionSpinAddon, ReelEvents, ReelSetEvents, ReelSetStoppedEvent, ReelStopEvent } from "@spawn/slot-machine";
import { filter } from "rxjs";

@consumer
export class NrgAttentionSpinAddon extends AttentionSpinAddon {
	protected initialize(): void {
		this.createSounds();
		this.createSpineAnimation();

		this.subscriptions.push(
			this.eventDispatcher
				.event$<ReelStopEvent>(ReelEvents.Stopped)
				.pipe(filter(({ payload: { reelIndex, isQuickSpin } }) => reelIndex === this.previousReelIndex() && isQuickSpin === false))
				.subscribe(() => this.onReelStopEvent()),
			this.eventDispatcher.event$<ReelSetStoppedEvent>(ReelSetEvents.Stopped).subscribe(() => {
				// reset the result to avoid retrigger for disabled reels
				this.activeRuleResult = undefined;

				void this.attentionSounds[this.reelIndex - 1]?.stop();
				this.reelController.setAddonInactive(this.reelIndex, NrgAttentionSpinAddon.name);

				for (const animation of this.attentionSpinAnimation) {
					animation.visible = false;
					animation.stop();
				}
			})
		);
	}

	/** The reel that starts the attention spin of this reel when it stops. */
	protected previousReelIndex(): number {
		return this.reelIndex - 1;
	}

	protected override onReelStopEvent(): void {
		if (this.reelController.isAddonActive(this.reelIndex, NrgAttentionSpinAddon.name)) {
			return;
		}

		if (this.activeRuleResult) {
			this.reelController.setAddonActive(this.reelIndex, NrgAttentionSpinAddon.name);
			this.attentionSpinAnimation[this.reelIndex].visible = true;
			this.attentionSpinAnimation[this.reelIndex].play();
			// We only need to play the attentionSpin sound once.
			if (this.activeRuleResult.startingReelIndex === this.reelIndex - 1) {
				void this.attentionSounds[this.reelIndex - 1]?.play();
				// this.ambientSoundController.fadeOutSound(); // FDM-161: don't fade out ambient sound during attention spin
			}
		}
	}
}
